import styled from 'styled-components';

export default styled.div`
  display: flex;
  font-family: 'Noto Sans', sans-serif;
  font-size: 12px;
  font-weight: bold;
  margin: auto;
  text-align: center;
`;
